<template>
  <div>
    <div class="row text-center justify-content-center" id="HeadlineDescription">
      <div class="col-md-8">
        <h3>Christian Tronhjem</h3>
      </div>
    </div>
    <div class="mt-5 row text-center justify-content-center">
      <div class="col-md-8">
        <p>
          I've spent the last 15 years working with sound in pretty much all its forms. My journey started in sound design and music production, where I've mixed, recorded, and created sound design for films, dance performances and music releases.
        </p>
        <p>
          In recent years, I've combined my love for audio with programming, developing audio systems for video games and music applications. Currently, I'm working as a Lead Game Audio Programmer at Ubisoft, where I help create immersive audio experiences for players.
        </p>
        <p>
          Whether it's crafting the perfect sound effect, mixing a film soundtrack, or writing code to make audio systems work seamlessly in games, I'm passionate about the technical and creative sides of sound.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'Home',
    }
</script>

<style scoped>
#HeadlineDescription {
    margin-top: 5rem;
}
</style>